import env from '@beam-australia/react-env';

const Env = {
  API_URL: env('API_URL'),
  SHOP_HOME_URL: env('SHOP_HOME_URL'),
  SHOP_PRODUCTS_URL: env('SHOP_PRODUCTS_URL'),
  SHOP_RESOURCES_URL: env('SHOP_RESOURCES_URL'),
  SHOP_DEVOTIONALS_URL: env('SHOP_DEVOTIONALS_URL'),
  TEACHER_PORTAL_URL: env('TEACHER_PORTAL_URL'),
  DISABLE_EDUCATOR_REGISTRATION: env('DISABLE_EDUCATOR_REGISTRATION') === 'true',
  GOOGLE_TAG_MANAGER_ID: env('GOOGLE_TAG_MANAGER_ID'),
  TEACHER_PORTAL: env('TEACHER_PORTAL') === 'true',
  LOGOUT_DESTINATION_URL: env('LOGOUT_DESTINATION_URL'),
};

export default Env;
